<template>
  <div
    :class="cartOpen ? 'mx-[119px]' : ''"
    class="flex flex-1 flex-col items-center custom-scroll-bar overflow-y-auto overflow-x-hidden"
  >
    <template v-for="group in groupedCartProducts" :key="group.category">
      <!-- category header -->
      <div class="w-full px-[12px] pt-[12px] pb-[4px]">
        <h4 class="text-right text-sm font-bold pb-[4px]">
          {{ group.category }}
        </h4>
      </div>
      <!-- products in group -->
      <div
        v-for="product in group.products"
        :key="product.id"
        :class="cartOpen ? 'px-[0] py-[8px] pl-[24px]' : ''"
        class="item w-full flex flex-row px-[12px] py-[12px] border-b"
      >
        <cart-product-shipping
          v-if="product.type === 'shipping'"
          :cartOpen="cartOpen"
          :cartProducts="cartProducts"
          :product="product"
        />
        <cart-product-collecting
          v-else-if="product.type === 'collecting'"
          :cartOpen="cartOpen"
          :cartProducts="cartProducts"
          :product="product"
        />
        <cart-product
          v-else
          :cartOpen="cartOpen"
          :cartProducts="cartProducts"
          :product="product"
        />
      </div>
    </template>
  </div>
</template>

<script>
import CartProductShipping from "@/components/Order/CartProductShipping.vue";
import CartProductCollecting from "@/components/Order/CartProductCollecting.vue";
import CartProduct from "@/components/Order/CartProduct.vue";

export default {
  name: "cart-products-list",
  components: { CartProduct, CartProductCollecting, CartProductShipping },
  props: {
    cartOpen: {
      type: Boolean,
      required: true,
    },
    cartProducts: {
      type: Array,
      default: [],
    },
  },
  computed: {
    groupedCartProducts() {
      const groups = [];
      const map = new Map();
      for (const product of this.cartProducts) {
        const category =
          product?.item_sale?.product?.category?.name ||
          product?.product?.category?.name ||
          product?.category ||
          "אחר";
        if (!map.has(category)) {
          map.set(category, []);
          groups.push({ category, products: map.get(category) });
        }
        map.get(category).push(product);
      }
      return groups;
    },
  },
};
</script>

<style>
</style>